/**
 * Copyright IBM Corp. 2022, 2026
 */

import { Suspense } from 'react'
import { Button } from '@hashicorp/mds-react'
import s from './style.module.css'

interface TwitterOEmbed {
	url: string
	author_name: string
	author_url: string
	html: string
	width: number
	height: number | null
	type: string
	cache_age: string
	provider_name: string
	provider_url: string
	version: string
}

export default async function TwitterEmbed({ url }) {
	const res = await fetch(
		`https://publish.x.com/oembed?url=${url}&theme=dark`,
		{
			method: 'GET',
		},
	)
	const embedData: TwitterOEmbed = await res.json()

	return (
		<div className={s.twitterEmbed}>
			<Suspense
				fallback={
					<div className={s.fallback}>
						<Button
							type="button"
							href={url}
							isHrefExternal={true}
							text="Visit X post"
							icon="external-link"
							iconPosition="trailing"
							color="secondary"
						/>
					</div>
				}
			>
				<div dangerouslySetInnerHTML={{ __html: embedData?.html }} />
			</Suspense>
		</div>
	)
}
